module.exports = __webpack_public_path__ + "static/media/CreateTimetable.b796fb25.png";